/**
 * TariffsMobile — мобильная раскладка «Тарифов» (design Handoff 4): шапка,
 * блоки Соло/Клиника и карточка-калькулятор; правка — bottom-sheet
 * (TariffEditSheet). Разметка блоков — в SoloBlock/ClinicBlock/CalculatorCard.
 * Справа в шапке резерв под гамбургер AppShell (pr-[60px]).
 */

import {History} from 'lucide-react';

import type {SaveClinicInput, TariffsBundle} from '@services/tariffs';
import {Loader} from '@components/ui/Loader';

import {TariffEditSheet} from '../TariffEditSheet';

import {CalculatorCard} from './CalculatorCard';
import {ClinicBlock} from './ClinicBlock';
import {SoloBlock} from './SoloBlock';

type TariffsMobileProps = {
  data?: TariffsBundle;
  isLoading: boolean;
  editing: 'solo' | 'clinic' | null;
  onEditSolo: () => void;
  onEditClinic: () => void;
  onCancel: () => void;
  onAskSaveSolo: (price: number) => void;
  onAskSaveClinic: (input: SaveClinicInput) => void;
  onOpenHistory: () => void;
};

export const TariffsMobile = ({
  data,
  isLoading,
  editing,
  onEditSolo,
  onEditClinic,
  onCancel,
  onAskSaveSolo,
  onAskSaveClinic,
  onOpenHistory,
}: TariffsMobileProps) => (
  <div className="flex min-h-full flex-col">
    <header className="flex items-center justify-between pb-3 pl-[18px] pr-[60px] pt-3">
      <div>
        <h1 className="text-[23px] font-bold -tracking-[.02em]">Тарифы</h1>
        <div className="mt-0.5 text-xs text-muted-foreground">Изменения — со след. продления</div>
      </div>
      <button
        onClick={onOpenHistory}
        aria-label="История изменений"
        className="grid size-10 shrink-0 self-start place-items-center rounded-xl border border-input bg-card text-muted-foreground"
      >
        <History className="size-[19px]" strokeWidth={1.8} />
      </button>
    </header>

    <div className="flex flex-col gap-3.5 px-4 pb-6 pt-0.5">
      {isLoading || !data ? (
        <div className="flex min-h-[360px] items-center justify-center">
          <Loader label="Загружаем тарифы…" />
        </div>
      ) : (
        <>
          <SoloBlock version={data.solo.version} price={data.solo.price} onEdit={onEditSolo} />
          <ClinicBlock clinic={data.clinic} onEdit={onEditClinic} />
          <CalculatorCard clinic={data.clinic} />
        </>
      )}
    </div>

    {data && (
      <TariffEditSheet
        editing={editing}
        solo={data.solo}
        clinic={data.clinic}
        onClose={onCancel}
        onAskSaveSolo={onAskSaveSolo}
        onAskSaveClinic={onAskSaveClinic}
      />
    )}
  </div>
);
